import { useState } from "react";
import { InvokeLLM } from "@/integrations/Core";
import { Button } from "@/components/ui/button";

export default function ResearchKeywords() {
  const [research, setResearch] = useState(null);
  const [loading, setLoading] = useState(false);

  const performResearch = async () => {
    setLoading(true);
    
    const result = await InvokeLLM({
      prompt: `Research the most popular and high-volume search keywords related to "tire changer machine" on Google. 
      
      Include:
      1. Top 20 high-volume keywords people search for
      2. Long-tail keywords with buying intent
      3. Question-based keywords (how to, what is, best, etc.)
      4. Comparison keywords (vs, versus, alternative)
      5. Popular pain points and problems people search for
      6. Trending topics in the tire changing industry
      
      Format as a structured list with search volume estimates and competition level.`,
      add_context_from_internet: true,
      response_json_schema: {
        type: "object",
        properties: {
          high_volume_keywords: {
            type: "array",
            items: {
              type: "object",
              properties: {
                keyword: { type: "string" },
                estimated_volume: { type: "string" },
                competition: { type: "string" }
              }
            }
          },
          long_tail_keywords: {
            type: "array",
            items: { type: "string" }
          },
          question_keywords: {
            type: "array",
            items: { type: "string" }
          },
          pain_points: {
            type: "array",
            items: { type: "string" }
          },
          trending_topics: {
            type: "array",
            items: { type: "string" }
          }
        }
      }
    });
    
    setResearch(result);
    setLoading(false);
  };

  return (
    <div className="p-8">
      <h1>Keyword Research</h1>
      <Button onClick={performResearch} disabled={loading}>
        {loading ? "Researching..." : "Research Keywords"}
      </Button>
      
      {research && (
        <pre className="mt-4 p-4 bg-gray-100 rounded">
          {JSON.stringify(research, null, 2)}
        </pre>
      )}
    </div>
  );
}